import { SearchMatchType } from '@aibees/elephant/types';
import { linkedinUrlValueFormatter } from '../components/filter-tags/utils';
import {
  FieldValidationType,
  FilterCategory,
  SearchFilterBase,
  SearchFilterType,
} from '../types';

export default function peopleInfoFilterConfig(): SearchFilterBase {
  return {
    name: 'People Info',
    icon: 'portrait',
    index: 0,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.CONTACT_DATA],
    pinned: true,
    items: [
      {
        index: 0,
        type: SearchFilterType.RADIO_GROUP,
        name: 'People info',
        icon: undefined,
        metadata: {
          singleEntry: true,
        },
        utils: {
          tags: {
            config: {
              showAsCard: true,
              tagsCardTitle: 'People info',
            },
          },
        },
        config: { labelKey: 'label', valueKey: 'value' },
        items: [
          {
            name: 'Full Name',
            type: SearchFilterType.TEXT_FIELD,
            icon: undefined,
            index: 0,
            layer: 4,
            exactMatch: {
              enabled: true,
              default: SearchMatchType.SMART,
            },
            key: 'value',
            field: 'fullName',
            metadata: {
              color: 'primary',
              placeholder: 'Enter Full Name',
              singleEntry: true,
            },
            open: true,
          },
          // TODO commented this because we will use it after
          // {
          //   name: 'Email Address',
          //   type: SearchFilterType.TEXT_FIELD,
          //   icon: undefined,
          //   index: 1,
          //   layer: 4,
          //   exactMatch: true,
          //   key: 'include_contact_email',
          //   field: 'include_contact_email',
          //   metadata: {
          //     color: 'primary',
          //     validation: {
          //       type: FieldValidationType.EMAIL,
          //       error: 'Kindly enter a valid email address.',
          //     },
          //     placeholder: 'Enter email address',
          //     singleEntry: true,
          //     info: `<p style='margin:0;'>We require your email to connect. Please ensure to provide a valid email.</p>`,
          //   },
          //   comingSoon: true,
          // },
          {
            name: 'LinkedIn Contact URL',
            type: SearchFilterType.TEXT_FIELD,
            icon: undefined,
            index: 2,
            layer: 4,
            key: 'include_linkedin_url_for_contact',
            field: 'include_linkedin_url_for_contact',
            utils: {
              valueFormatter: linkedinUrlValueFormatter,
            },
            metadata: {
              color: 'primary',
              validation: {
                type: FieldValidationType.PEOPLE_LINKEDIN_URL,
                error: 'Kindly enter a valid LinkedIn Contact URL.',
              },
              placeholder: 'Enter LinkedIn Contact URL',
              singleEntry: true,
              delimiter: '::',
            },
          },
          // TODO commented this because we will use it after
          // {
          //   name: 'Phone Number',
          //   type: SearchFilterType.TEXT_FIELD,
          //   icon: undefined,
          //   index: 3,
          //   layer: 4,
          //   exactMatch: true,
          //   key: 'include_phone_numbers_for_contact',
          //   field: 'include_phone_numbers_for_contact',
          //   metadata: {
          //     color: 'primary',
          //     validation: {
          //       type: FieldValidationType.PHONE,
          //       error: 'Kindly enter a valid phone number.',
          //     },
          //     placeholder: 'Enter phone number',
          //     singleEntry: true,
          //   },
          //   comingSoon: true,
          // },
        ],
      },
    ],
  };
}
